import { Stack, styled } from '@mui/material'
import { jwtDecode, JwtPayload } from 'jwt-decode'
import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useValidateEmail } from '@/data/auth'
import { PATHS } from '@/router/constants'
import { useStore } from '@/store'
import InfoComponent from '@/ui/organisms/InfoComponent'
import { isNilOrEmpty } from '@/utils'

const StyledDiv = styled(Stack)(`
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 100%;
    height: 100%;
    gap: 2rem;
  `)

interface DecodedToken extends JwtPayload {
  id: string
}

export const EmailValidationTemplate: React.FC = () => {
  const { mutate: validateEmail } = useValidateEmail()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [showErrorMessage, setShowErrorMessage] = React.useState(false)
  const { setUserId } = useStore()

  useEffect(() => {
    if (isNilOrEmpty(token)) {
      setShowErrorMessage(true)
    } else {
      const tokenStr = Array.isArray(token) ? token[0] : token
      const decoded = jwtDecode<DecodedToken>(tokenStr)
      const { id } = decoded
      setUserId(id)
      validateEmail(
        { body: { token } },
        {
          onSuccess: () => {
            navigate(PATHS.LOGIN)
          },
          onError: () => {
            setShowErrorMessage(true)
          },
        }
      )
    }
  }, [navigate, setUserId, token, validateEmail])

  return (
    <>
      {showErrorMessage && (
        <StyledDiv maxWidth='31.25rem'>
          <InfoComponent
            title='The email could not be validated'
            description='Please go to the mail we sent you and click on the link to validate your email.'
            image='/images/whistle.svg'
            imageAlt='Alert Illustration'
            buttonMessage='Go to Login'
            buttonOnClick={() => navigate(PATHS.LOGIN)}
          />
        </StyledDiv>
      )}
    </>
  )
}
